import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "outer" }
const _hoisted_2 = { class: "row g-0 align-items-center mb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-md" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "display-3 fw-normal mb-3 mb-md-0" }, "車輌チェックシート")
], -1)
const _hoisted_4 = { class: "col-12 col-md-7 col-lg-6 col-xl-5" }
const _hoisted_5 = { class: "table table-bordered" }
const _hoisted_6 = { class: "border-1 lh-md" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("td", { class: "align-middle text-center bg-g05 text-nowrap px-lg-3" }, " 担当者 ", -1)
const _hoisted_8 = { class: "align-middle px-lg-3" }
const _hoisted_9 = ["label"]
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "invalid-feedback" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", { class: "align-middle text-center bg-g05 text-nowrap px-lg-3" }, " 実施日 ", -1)
const _hoisted_13 = { class: "align-middle px-lg-3" }
const _hoisted_14 = { class: "col" }
const _hoisted_15 = { class: "invalid-feedback" }
const _hoisted_16 = { class: "row g-4 mb-4" }
const _hoisted_17 = { class: "col-12 col-lg" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h6", { class: "bg-line text-center py-1" }, "日常点検項目", -1)
const _hoisted_19 = { class: "table table-bordered mb-2" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("thead", { class: "border-1 lh-md" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-center bg-g05 text-nowrap px-3 py-1"
    }, " 箇所 "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-center bg-g05 text-nowrap px-3 py-1"
    }, " 内容 "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-center bg-g05 text-nowrap px-3 py-1 w-10"
    }, " 良否 ")
  ])
], -1)
const _hoisted_21 = { class: "border-1 lh-md" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("td", {
  class: "align-middle text-center px-lg-3",
  rowspan: "3"
}, " ブレーキ ", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("td", { class: "align-middle px-lg-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "form-check-label d-block",
    for: "brakeRoom"
  }, " ブレーキの踏みしろが適当 ")
], -1)
const _hoisted_24 = { class: "align-middle text-center" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("td", { class: "align-middle px-lg-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "form-check-label d-block",
    for: "brakeEffective"
  }, " ブレーキの効きが十分 ")
], -1)
const _hoisted_26 = { class: "align-middle text-center" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("td", { class: "align-middle px-lg-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "form-check-label d-block",
    for: "brakeFluid"
  }, " ブレーキフルードの液量が適当 ")
], -1)
const _hoisted_28 = { class: "align-middle text-center" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("td", {
  class: "align-middle text-center px-lg-3",
  rowspan: "3"
}, " タイヤ ", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("td", { class: "align-middle px-lg-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "form-check-label d-block",
    for: "tireAir"
  }, " タイヤの空気圧が適当 ")
], -1)
const _hoisted_31 = { class: "align-middle text-center" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("td", { class: "align-middle px-lg-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "form-check-label d-block",
    for: "tireGrooveDepth"
  }, " タイヤの溝の深さが十分 ")
], -1)
const _hoisted_33 = { class: "align-middle text-center" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("td", { class: "align-middle px-lg-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "form-check-label d-block",
    for: "tire_no_damage"
  }, " 亀裂および損傷がなく異常な摩耗なし ")
], -1)
const _hoisted_35 = { class: "align-middle text-center" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("td", {
  class: "align-middle text-center px-lg-3",
  rowspan: "2"
}, " バッテリー ", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("td", { class: "align-middle px-lg-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "form-check-label d-block",
    for: "batteryFull"
  }, " 液量が適当 ")
], -1)
const _hoisted_38 = { class: "align-middle text-center" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("td", { class: "align-middle px-lg-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "form-check-label d-block",
    for: "batteryElec"
  }, " 電気系統の作動状況が良好 ")
], -1)
const _hoisted_40 = { class: "align-middle text-center" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("td", {
  class: "align-middle text-center px-lg-3",
  rowspan: "2"
}, [
  /*#__PURE__*/_createTextVNode(" 灯火装置、"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("方向指示器 ")
], -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("td", { class: "align-middle px-lg-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "form-check-label d-block",
    for: "lampsNoDefect"
  }, " 点灯または点滅具合に不良なし ")
], -1)
const _hoisted_43 = { class: "align-middle text-center" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("td", { class: "align-middle px-lg-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "form-check-label d-block",
    for: "lampsNoDamage"
  }, " 汚れ、損傷がない ")
], -1)
const _hoisted_45 = { class: "align-middle text-center" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("td", {
  class: "align-middle text-center px-lg-3",
  rowspan: "4"
}, " 原動機 ", -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("td", { class: "align-middle px-lg-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "form-check-label d-block",
    for: "engineOil"
  }, " 冷却水およびエンジンオイルの量が適当 ")
], -1)
const _hoisted_48 = { class: "align-middle text-center" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("td", { class: "align-middle px-lg-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "form-check-label d-block",
    for: "engineFunbelt"
  }, " ファンベルトの張り具合が適当であり損傷なし ")
], -1)
const _hoisted_50 = { class: "align-middle text-center" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("td", { class: "align-middle px-lg-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "form-check-label d-block",
    for: "engineNoDefect"
  }, " 原動機のかかり具合に不良なく異常音がない ")
], -1)
const _hoisted_52 = { class: "align-middle text-center" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("td", { class: "align-middle px-lg-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "form-check-label d-block",
    for: "speedControl"
  }, " 低速および加速の状態が適当 ")
], -1)
const _hoisted_54 = { class: "align-middle text-center" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("td", {
  class: "align-middle text-center px-lg-3",
  rowspan: "2"
}, [
  /*#__PURE__*/_createTextVNode(" ウィンドウ・"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("ウォッシャー、"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("ワイパー ")
], -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("td", { class: "align-middle px-lg-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "form-check-label d-block",
    for: "windowLiquid"
  }, " 液量が適当で噴射状態に不良なし ")
], -1)
const _hoisted_57 = { class: "align-middle text-center" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("td", { class: "align-middle px-lg-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "form-check-label d-block",
    for: "windowWiper"
  }, " ワイパーの払拭状態に不良なし ")
], -1)
const _hoisted_59 = { class: "align-middle text-center" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("td", {
  class: "align-middle text-center px-lg-3",
  rowspan: "4"
}, " 装備品 ", -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("td", { class: "align-middle px-lg-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "form-check-label d-block",
    for: "equipEtc"
  }, " ETC ")
], -1)
const _hoisted_62 = { class: "align-middle text-center" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("td", { class: "align-middle px-lg-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "form-check-label d-block",
    for: "driveRecorder"
  }, " ドライブレコーダー ")
], -1)
const _hoisted_64 = { class: "align-middle text-center" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("td", { class: "align-middle px-lg-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "form-check-label d-block",
    for: "equipNavi"
  }, " ナビ（CD/DVD/HDD） ")
], -1)
const _hoisted_66 = { class: "align-middle text-center" }
const _hoisted_67 = { class: "row g-2" }
const _hoisted_68 = { class: "col-6" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("h6", { class: "bg-line text-center py-1" }, "備品など", -1)
const _hoisted_70 = { class: "table table-bordered" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("thead", { class: "border-1 lh-md" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-center bg-g05 text-nowrap px-3 py-1"
    }, " 内容 "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-center bg-g05 text-nowrap px-3 py-1 w-10"
    }, " 良否 ")
  ])
], -1)
const _hoisted_72 = { class: "border-1 lh-md" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("td", { class: "align-middle px-lg-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "form-check-label d-block",
    for: "smokeBomb"
  }, " 発煙筒 ")
], -1)
const _hoisted_74 = { class: "align-middle text-center" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("td", { class: "align-middle px-lg-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "form-check-label d-block",
    for: "tools"
  }, " 工具・ジャッキ ")
], -1)
const _hoisted_76 = { class: "align-middle text-center" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("td", { class: "align-middle px-lg-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "form-check-label d-block",
    for: "spareTire"
  }, " スペアタイヤ ")
], -1)
const _hoisted_78 = { class: "align-middle text-center" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("td", { class: "align-middle px-lg-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "form-check-label d-block",
    for: "triangular"
  }, " 三角表示板 ")
], -1)
const _hoisted_80 = { class: "align-middle text-center" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("td", { class: "align-middle px-lg-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "form-check-label d-block",
    for: "repairKit"
  }, " 修理キット ")
], -1)
const _hoisted_82 = { class: "align-middle text-center" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("td", { class: "align-middle px-lg-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "form-check-label d-block",
    for: "winch"
  }, " ウインチ ")
], -1)
const _hoisted_84 = { class: "align-middle text-center" }
const _hoisted_85 = { class: "col-6" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("h6", { class: "bg-line text-center py-1" }, "洗車清掃", -1)
const _hoisted_87 = { class: "table table-bordered mb-2" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("thead", { class: "border-1 lh-md" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-center bg-g05 text-nowrap px-3 py-1"
    }, " 内容 "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-center bg-g05 text-nowrap px-3 py-1 w-10"
    }, " 良否 ")
  ])
], -1)
const _hoisted_89 = { class: "border-1 lh-md" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("td", { class: "align-middle px-lg-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "form-check-label d-block",
    for: "carWashExterior"
  }, " 外装 ")
], -1)
const _hoisted_91 = { class: "align-middle text-center" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("td", { class: "align-middle px-lg-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "form-check-label d-block",
    for: "carWashInterior"
  }, " 内装 ")
], -1)
const _hoisted_93 = { class: "align-middle text-center" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("h6", { class: "bg-line text-center py-1" }, "その他", -1)
const _hoisted_95 = { class: "table table-bordered" }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("thead", { class: "border-1 lh-md" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-center bg-g05 text-nowrap px-3 py-1"
    }, " 内容 "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-center bg-g05 text-nowrap px-3 py-1 w-10"
    }, " 良否 ")
  ])
], -1)
const _hoisted_97 = { class: "border-1 lh-md" }
const _hoisted_98 = /*#__PURE__*/_createElementVNode("td", { class: "align-middle px-lg-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "form-check-label d-block",
    for: "scratchCheck"
  }, " キズチェック ")
], -1)
const _hoisted_99 = { class: "align-middle text-center" }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("td", { class: "align-middle px-lg-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "form-check-label d-block",
    for: "presence"
  }, " 立会い ")
], -1)
const _hoisted_101 = { class: "align-middle text-center" }
const _hoisted_102 = { class: "col-12 col-lg" }
const _hoisted_103 = /*#__PURE__*/_createElementVNode("h6", { class: "bg-line text-center py-1" }, "車輌外装チェック", -1)
const _hoisted_104 = { class: "border p-4 mb-2" }
const _hoisted_105 = {
  class: "w-100",
  style: {"background-image":"url(/images/check_01.png)","background-size":"100% 100%","background-repeat":"no-repeat"}
}
const _hoisted_106 = ["id", "data-row", "data-col"]
const _hoisted_107 = /*#__PURE__*/_createElementVNode("h6", { class: "bg-line text-center py-1" }, "車輌内装チェック", -1)
const _hoisted_108 = { class: "border p-4" }
const _hoisted_109 = {
  class: "w-100",
  style: {"background-image":"url(/images/check_02.png)","background-size":"100% 100%","background-repeat":"no-repeat"}
}
const _hoisted_110 = ["id", "data-row", "data-col"]
const _hoisted_111 = { class: "border p-3 mb-4" }
const _hoisted_112 = /*#__PURE__*/_createElementVNode("label", {
  for: "memo",
  class: "form-label mb-1"
}, " 備考 ", -1)
const _hoisted_113 = { class: "border p-3 mb-4" }
const _hoisted_114 = /*#__PURE__*/_createStaticVNode("<h4 class=\"h5 fw-normal mb-1\">確認事項</h4><p class=\"kome\"> ①私は暴力団、暴力団員等、暴力団関連企業・又はこれらの密接交際者ではありません。 </p><p class=\"kome\"> ②この度の取引に係る、関係者・借受人・運転者・使用者のいずれも、暴力団、暴力団員等、暴力団関連企業・又はこれらの密接交際者ではありません。 </p><p class=\"kome\"> ③後日、上記確認事項に相違する事が判明した場合は、貴社より催告を受けなくても一切の契約の解除に応じ、損害賠償の請求も致しません。また、貴社から賃貸されているレンタカー及び物品はすみやかに返済いたします。 </p><p class=\"kome\"> ④私は、貴社が必要と判断した場合、本記載事項について各県警察署への照会を承諾いたします。 </p><hr class=\"my-3\">", 6)
const _hoisted_120 = { class: "row g-0 justify-content-center row-cols-auto" }
const _hoisted_121 = { class: "col" }
const _hoisted_122 = { class: "form-check" }
const _hoisted_123 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "isAgreement"
}, " 上記、確認事項について同意する ", -1)
const _hoisted_124 = { class: "invalid-feedback" }
const _hoisted_125 = { class: "border p-3 p-md-4 px-md-5" }
const _hoisted_126 = /*#__PURE__*/_createElementVNode("h4", { class: "h5 fw-normal text-md-center mb-2" }, " 私は貴社の定めた貸渡約款に基づき貴社の自動車を借受けます。 ", -1)
const _hoisted_127 = /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, "借受人署名", -1)
const _hoisted_128 = { class: "text-white text-center mb-2" }
const _hoisted_129 = { class: "invalid-feedback" }
const _hoisted_130 = {
  key: 0,
  class: "text-end mb-2"
}
const _hoisted_131 = {
  key: 1,
  class: "text-end"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Sign = _resolveComponent("Sign")!
  const _component_ExteriorCheckModal = _resolveComponent("ExteriorCheckModal")!
  const _component_InteriorCheckModal = _resolveComponent("InteriorCheckModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _createElementVNode("tbody", _hoisted_6, [
              _createElementVNode("tr", null, [
                _hoisted_7,
                _createElementVNode("td", _hoisted_8, [
                  _withDirectives(_createElementVNode("select", {
                    id: "checkManagerId",
                    name: "checkManagerId",
                    class: "form-select form-select-sm",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.rentalContractEditForm.maintenancePersonId) = $event)),
                    disabled: ""
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usersForSinglePulldownByVue
                      .users[0], (department, id) => {
                      return (_openBlock(), _createElementBlock("optgroup", {
                        label: department.departmentName,
                        key: id
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(department.users, (user) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: user.id,
                            key: user.id
                          }, _toDisplayString(user.name), 9, _hoisted_10))
                        }), 128))
                      ], 8, _hoisted_9))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.rentalContractEditForm.maintenancePersonId]
                  ]),
                  _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.errors.checkManagerId.message), 1)
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_12,
                _createElementVNode("td", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      id: "processedDate",
                      name: "processedDate",
                      class: "form-control form-control-sm",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.rentalContractEditForm.maintenanceDate) = $event)),
                      placeholder: "カレンダーから選択",
                      readonly: ""
                    }, null, 512), [
                      [_vModelText, _ctx.rentalContractEditForm.maintenanceDate]
                    ]),
                    _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.errors.processedDate.message), 1)
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("table", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("tbody", _hoisted_21, [
              _createElementVNode("tr", null, [
                _hoisted_22,
                _hoisted_23,
                _createElementVNode("td", _hoisted_24, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "brakeRoom",
                    name: "brakeRoom",
                    class: "form-check-input",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.rentalContractEditForm.brakeRoom) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.rentalContractEditForm.brakeRoom]
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_25,
                _createElementVNode("td", _hoisted_26, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "brakeEffective",
                    name: "brakeEffective",
                    class: "form-check-input",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.rentalContractEditForm.brakeEffective) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.rentalContractEditForm.brakeEffective]
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_27,
                _createElementVNode("td", _hoisted_28, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "brakeFluid",
                    name: "brakeFluid",
                    class: "form-check-input",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.rentalContractEditForm.brakeFluid) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.rentalContractEditForm.brakeFluid]
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_29,
                _hoisted_30,
                _createElementVNode("td", _hoisted_31, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "tireAir",
                    name: "tireAir",
                    class: "form-check-input",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.rentalContractEditForm.tireAir) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.rentalContractEditForm.tireAir]
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_32,
                _createElementVNode("td", _hoisted_33, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "tireGrooveDepth",
                    name: "tireGrooveDepth",
                    class: "form-check-input",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.rentalContractEditForm.tireGrooveDepth) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.rentalContractEditForm.tireGrooveDepth]
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_34,
                _createElementVNode("td", _hoisted_35, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "tire_no_damage",
                    name: "tire_no_damage",
                    class: "form-check-input",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.rentalContractEditForm.tireNoDamage) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.rentalContractEditForm.tireNoDamage]
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_36,
                _hoisted_37,
                _createElementVNode("td", _hoisted_38, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "batteryFull",
                    name: "batteryFull",
                    class: "form-check-input",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.rentalContractEditForm.batteryFull) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.rentalContractEditForm.batteryFull]
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_39,
                _createElementVNode("td", _hoisted_40, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "batteryElec",
                    name: "batteryElec",
                    class: "form-check-input",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.rentalContractEditForm.batteryElec) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.rentalContractEditForm.batteryElec]
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_41,
                _hoisted_42,
                _createElementVNode("td", _hoisted_43, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "lampsNoDefect",
                    name: "lampsNoDefect",
                    class: "form-check-input",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.rentalContractEditForm.lampsNoDefect) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.rentalContractEditForm.lampsNoDefect]
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_44,
                _createElementVNode("td", _hoisted_45, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "lampsNoDamage",
                    name: "lampsNoDamage",
                    class: "form-check-input",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.rentalContractEditForm.lampsNoDamage) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.rentalContractEditForm.lampsNoDamage]
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_46,
                _hoisted_47,
                _createElementVNode("td", _hoisted_48, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "engineOil",
                    name: "engineOil",
                    class: "form-check-input",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.rentalContractEditForm.engineOil) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.rentalContractEditForm.engineOil]
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_49,
                _createElementVNode("td", _hoisted_50, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "engineFunbelt",
                    name: "engineFunbelt",
                    class: "form-check-input",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.rentalContractEditForm.engineFunbelt) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.rentalContractEditForm.engineFunbelt]
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_51,
                _createElementVNode("td", _hoisted_52, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "engineNoDefect",
                    name: "engineNoDefect",
                    class: "form-check-input",
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.rentalContractEditForm.engineNoDefect) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.rentalContractEditForm.engineNoDefect]
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_53,
                _createElementVNode("td", _hoisted_54, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "speedControl",
                    name: "speedControl",
                    class: "form-check-input",
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.rentalContractEditForm.speedControl) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.rentalContractEditForm.speedControl]
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_55,
                _hoisted_56,
                _createElementVNode("td", _hoisted_57, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "windowLiquid",
                    name: "windowLiquid",
                    class: "form-check-input",
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.rentalContractEditForm.windowLiquid) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.rentalContractEditForm.windowLiquid]
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_58,
                _createElementVNode("td", _hoisted_59, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "windowWiper",
                    name: "windowWiper",
                    class: "form-check-input",
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.rentalContractEditForm.windowWiper) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.rentalContractEditForm.windowWiper]
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_60,
                _hoisted_61,
                _createElementVNode("td", _hoisted_62, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "equipEtc",
                    name: "equipEtc",
                    class: "form-check-input",
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.rentalContractEditForm.equipEtc) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.rentalContractEditForm.equipEtc]
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_63,
                _createElementVNode("td", _hoisted_64, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "driveRecorder",
                    name: "driveRecorder",
                    class: "form-check-input",
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.rentalContractEditForm.driveRecorder) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.rentalContractEditForm.driveRecorder]
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_65,
                _createElementVNode("td", _hoisted_66, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "equipNavi",
                    name: "equipNavi",
                    class: "form-check-input",
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.rentalContractEditForm.equipNavi) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.rentalContractEditForm.equipNavi]
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_67, [
            _createElementVNode("div", _hoisted_68, [
              _hoisted_69,
              _createElementVNode("table", _hoisted_70, [
                _hoisted_71,
                _createElementVNode("tbody", _hoisted_72, [
                  _createElementVNode("tr", null, [
                    _hoisted_73,
                    _createElementVNode("td", _hoisted_74, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        id: "smokeBomb",
                        name: "smokeBomb",
                        class: "form-check-input",
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.rentalContractEditForm.smokeBomb) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.rentalContractEditForm.smokeBomb]
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_75,
                    _createElementVNode("td", _hoisted_76, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        id: "tools",
                        name: "tools",
                        class: "form-check-input",
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.rentalContractEditForm.tools) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.rentalContractEditForm.tools]
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_77,
                    _createElementVNode("td", _hoisted_78, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        id: "spareTire",
                        name: "spareTire",
                        class: "form-check-input",
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.rentalContractEditForm.spareTire) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.rentalContractEditForm.spareTire]
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_79,
                    _createElementVNode("td", _hoisted_80, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        id: "triangular",
                        name: "triangular",
                        class: "form-check-input",
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.rentalContractEditForm.triangular) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.rentalContractEditForm.triangular]
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_81,
                    _createElementVNode("td", _hoisted_82, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        id: "repairKit",
                        name: "repairKit",
                        class: "form-check-input",
                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.rentalContractEditForm.repairKit) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.rentalContractEditForm.repairKit]
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_83,
                    _createElementVNode("td", _hoisted_84, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        id: "winch",
                        name: "winch",
                        class: "form-check-input",
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.rentalContractEditForm.winch) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.rentalContractEditForm.winch]
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_85, [
              _hoisted_86,
              _createElementVNode("table", _hoisted_87, [
                _hoisted_88,
                _createElementVNode("tbody", _hoisted_89, [
                  _createElementVNode("tr", null, [
                    _hoisted_90,
                    _createElementVNode("td", _hoisted_91, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        id: "carWashExterior",
                        name: "carWashExterior",
                        class: "form-check-input",
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.rentalContractEditForm.carWashExterior) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.rentalContractEditForm.carWashExterior]
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_92,
                    _createElementVNode("td", _hoisted_93, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        id: "carWashInterior",
                        name: "carWashInterior",
                        class: "form-check-input",
                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.rentalContractEditForm.carWashInterior) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.rentalContractEditForm.carWashInterior]
                      ])
                    ])
                  ])
                ])
              ]),
              _hoisted_94,
              _createElementVNode("table", _hoisted_95, [
                _hoisted_96,
                _createElementVNode("tbody", _hoisted_97, [
                  _createElementVNode("tr", null, [
                    _hoisted_98,
                    _createElementVNode("td", _hoisted_99, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        id: "scratchCheck",
                        name: "scratchCheck",
                        class: "form-check-input",
                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.rentalContractEditForm.scratchCheck) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.rentalContractEditForm.scratchCheck]
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_100,
                    _createElementVNode("td", _hoisted_101, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        id: "presence",
                        name: "presence",
                        class: "form-check-input",
                        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.rentalContractEditForm.presence) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.rentalContractEditForm.presence]
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_102, [
          _hoisted_103,
          _createElementVNode("div", _hoisted_104, [
            _createElementVNode("div", {
              class: "ph position-relative",
              onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.showExteriorCheckModal()))
            }, [
              _createElementVNode("div", _hoisted_105, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exteriorCheckRow, (m) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "row d-flex flex-nowrap px-2",
                    key: m
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exteriorCheckCol, (n) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: n,
                        id: 'exterior_' + m + '_' + n,
                        class: _normalizeClass(['exterior_' + m + '_' + n, "col d-flex align-items-center justify-content-center"]),
                        style: {"height":"40px","font-size":"200%"},
                        "data-row": m,
                        "data-col": n
                      }, null, 10, _hoisted_106))
                    }), 128))
                  ]))
                }), 128))
              ])
            ]),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.rentalContractEditForm.exteriorCheck) = $event)),
              type: "hidden",
              id: "exteriorCheck",
              name: "exteriorCheck"
            }, null, 512), [
              [_vModelText, _ctx.rentalContractEditForm.exteriorCheck]
            ])
          ]),
          _hoisted_107,
          _createElementVNode("div", _hoisted_108, [
            _createElementVNode("div", {
              class: "ph",
              onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.showInteriorCheckModal()))
            }, [
              _createElementVNode("div", _hoisted_109, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.interiorCheckRow, (m) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "row d-flex flex-nowrap px-2",
                    key: m
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.interiorCheckCol, (n) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: n,
                        id: 'interior_' + m + '_' + n,
                        class: _normalizeClass(['interior_' + m + '_' + n, "col d-flex align-items-center justify-content-center"]),
                        style: {"height":"90px","font-size":"200%"},
                        "data-row": m,
                        "data-col": n
                      }, null, 10, _hoisted_110))
                    }), 128))
                  ]))
                }), 128))
              ])
            ]),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.rentalContractEditForm.interiorCheck) = $event)),
              type: "hidden",
              id: "interiorCheck",
              name: "interiorCheck"
            }, null, 512), [
              [_vModelText, _ctx.rentalContractEditForm.interiorCheck]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_111, [
        _hoisted_112,
        _withDirectives(_createElementVNode("textarea", {
          id: "memo",
          name: "memo",
          class: "form-control",
          "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.rentalContractEditForm.memo) = $event)),
          rows: "3"
        }, null, 512), [
          [_vModelText, _ctx.rentalContractEditForm.memo]
        ])
      ]),
      _createElementVNode("div", _hoisted_113, [
        _hoisted_114,
        _createElementVNode("div", _hoisted_120, [
          _createElementVNode("div", _hoisted_121, [
            _createElementVNode("div", _hoisted_122, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                id: "isAgreement",
                name: "isAgreement",
                class: "form-check-input",
                "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.rentalContractEditForm.isAgreement) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.rentalContractEditForm.isAgreement]
              ]),
              _hoisted_123,
              _createElementVNode("div", _hoisted_124, _toDisplayString(_ctx.errors.isAgreement.message), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_125, [
        _hoisted_126,
        _hoisted_127,
        _createElementVNode("div", _hoisted_128, [
          _createVNode(_component_Sign),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.rentalContractEditForm.signaturePath) = $event)),
            type: "hidden",
            id: "signaturePath",
            name: "signaturePath"
          }, null, 512), [
            [_vModelText, _ctx.rentalContractEditForm.signaturePath]
          ]),
          _createElementVNode("div", _hoisted_129, _toDisplayString(_ctx.errors.signaturePath.message), 1)
        ]),
        (_ctx.isShow.canvas)
          ? (_openBlock(), _createElementBlock("div", _hoisted_130, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-secondary rounded-pill",
                onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.canvasClear()))
              }, " クリア ")
            ]))
          : _createCommentVNode("", true),
        (_ctx.rentalContractEditForm.registrationAt)
          ? (_openBlock(), _createElementBlock("p", _hoisted_131, _toDisplayString(_ctx.rentalContractEditForm.registrationAt), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_ExteriorCheckModal),
    _createVNode(_component_InteriorCheckModal)
  ], 64))
}